export default __webpack_public_path__ + "static/media/people1.0970060c.jpeg";